import { schemaToForm } from './convert.js';
/** "Choice" for a text field with allowed values; the plain type otherwise. */
const typeLabel = (f) => (f.options !== undefined ? `${f.type} (choice)` : f.type);
function flatten(schema) {
    const out = new Map();
    const res = schemaToForm(schema);
    const add = (path, f) => out.set(path, { type: f.type, instruction: f.instruction, inferenceType: f.inferenceType, options: f.options });
    if (res.form) {
        for (const node of res.form.fields) {
            if (node.kind === 'field')
                add(node.name, node);
            else if (node.kind === 'group') {
                out.set(node.name, { type: 'group', instruction: node.description, inferenceType: '' });
                node.fields.forEach((f) => add(`${node.name}.${f.name}`, f));
            }
            else {
                out.set(node.name, { type: 'table', instruction: node.instruction, inferenceType: '' });
                node.columns.forEach((f) => add(`${node.name}[].${f.name}`, f));
            }
        }
        return out;
    }
    // Schemas the form cannot represent: compare top-level properties as JSON.
    for (const [k, v] of Object.entries(schema.properties ?? {})) {
        out.set(k, { type: JSON.stringify(v), instruction: '', inferenceType: '' });
    }
    return out;
}
const describeType = (f) => (f.options !== undefined ? typeLabel(f) : f.type);
export function diffSchemas(a, b) {
    const before = flatten(a);
    const after = flatten(b);
    const entries = [];
    for (const [path, f] of before) {
        const g = after.get(path);
        if (!g) {
            entries.push({ path, kind: 'removed', before: describeType(f) });
            continue;
        }
        if (f.type !== g.type)
            entries.push({ path, kind: 'type', before: f.type, after: g.type });
        if (f.instruction !== g.instruction)
            entries.push({ path, kind: 'instruction', before: f.instruction, after: g.instruction });
        if (f.inferenceType !== g.inferenceType)
            entries.push({ path, kind: 'inferenceType', before: f.inferenceType, after: g.inferenceType });
        const fo = f.options ?? [];
        const go = g.options ?? [];
        const added = go.filter((o) => !fo.includes(o));
        const removed = fo.filter((o) => !go.includes(o));
        if (JSON.stringify(fo) !== JSON.stringify(go) || (f.options === undefined) !== (g.options === undefined)) {
            entries.push({
                path,
                kind: 'options',
                before: f.options === undefined ? 'Any value' : fo.join(', '),
                after: g.options === undefined ? 'Any value' : go.join(', '),
                added,
                removed,
            });
        }
    }
    for (const [path, g] of after)
        if (!before.has(path))
            entries.push({ path, kind: 'added', after: describeType(g) });
    return entries;
}
/** One-line summary of an `options` entry: "Added: A, B. Removed: C." */
export function describeOptionsChange(e) {
    const parts = [];
    if (e.added && e.added.length > 0)
        parts.push(`Added: ${e.added.join(', ')}.`);
    if (e.removed && e.removed.length > 0)
        parts.push(`Removed: ${e.removed.join(', ')}.`);
    return parts.join(' ') || 'Order changed.';
}
//# sourceMappingURL=diff.js.map